import { Drawer as BaseDrawer } from '@base-ui/react/drawer'

const { Root, Portal, Description, Close, Viewport } = BaseDrawer
export { Close, Description, Portal, Root, Viewport }

export { Backdrop } from './backdrop'
export { Content } from './content'
export { Footer } from './footer'
export { Header } from './header'
export { Popup } from './popup'
export { SwipeArea } from './swipe-area'
export { Title } from './title'
export { Trigger } from './trigger'
